"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_TRANSLATION = exports.DEFAULT_PRODUCT_IMG_WIDTH = exports.DEFAULT_PRODUCT_IMG_HEIGHT = exports.DEFAULT_LOCALE = exports.DEFAULT_CURRENCY_FORMAT = exports.DEFAULT_CURRENCY = exports.DEFAULT_BG_COLOR = void 0;
var DEFAULT_TRANSLATION = {
  totalPayment: 'Total payment',
  validUntil: 'Valid until'
};
exports.DEFAULT_TRANSLATION = DEFAULT_TRANSLATION;
var DEFAULT_CURRENCY_FORMAT = 'FLOAT';
exports.DEFAULT_CURRENCY_FORMAT = DEFAULT_CURRENCY_FORMAT;
var DEFAULT_CURRENCY = 'MYR';
exports.DEFAULT_CURRENCY = DEFAULT_CURRENCY;
var DEFAULT_LOCALE = 'en-gb';
exports.DEFAULT_LOCALE = DEFAULT_LOCALE;
var DEFAULT_BG_COLOR = '#F8F8F8';
exports.DEFAULT_BG_COLOR = DEFAULT_BG_COLOR;
var DEFAULT_PRODUCT_IMG_HEIGHT = '68px';
exports.DEFAULT_PRODUCT_IMG_HEIGHT = DEFAULT_PRODUCT_IMG_HEIGHT;
var DEFAULT_PRODUCT_IMG_WIDTH = '68px';
exports.DEFAULT_PRODUCT_IMG_WIDTH = DEFAULT_PRODUCT_IMG_WIDTH;